module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MzkiIGhlaWdodD0iNTM5IiB2aWV3Qm94PSIwIDAgNTM5IDUzOSI+PHJlY3Qgd2lkdGg9IjUzOSIgaGVpZ2h0PSI1MzkiIHg9IjExOCIgeT0iNDU0NiIgZmlsbD0iI0U4RENGQyIgZmlsbC1ydWxlPSJldmVub2RkIiByeD0iNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExOCAtNDU0NikiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/fundamentals-bg.svg
// module id = Hdrm
// module chunks = 0